import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import productData from '../data/productData.json';
import variationData from '../data/variationData.json';
import { Variation } from '../data/interfaces/Variation';
import GalleryGroup from './GalleryGroup';
import ProductPageHeader from './ProductPageHeader';
import DescriptionGroup from './DescriptionGroup';
import AddonGroup from './AddonGroup';
import { API_BASE_URL } from '../data/objects/gameColor';
import RelatedGroup from './RelatedGroup';

const ProductPage: React.FC = () => {
    const { slug, variationId } = useParams<{ slug: string; variationId?: string }>();
    const [variations, setVariations] = useState<Variation[]>([]);
    const [selectedVariation, setSelectedVariation] = useState<Variation | null>(null);
    const [downloadTypes, setDownloadTypes] = useState<string[]>([]);
    const product = productData.find((p) => p.slug === slug) || null;

    useEffect(() => {
        if (product) {
            document.title = `SecretAria - ${product.title}`;

            //const productVariations = variationData
            //    .filter((v) => v.releaseId === product.id)
            //    .map((v) => ({
            //        ...v,
            //        description: v.description.map((d) => ({
            //            ...d,
            //            type: d.type as "text" | "link",
            //        })),
            //    }));
            const productVariations = variationData
                .filter((v) => v.releaseId === product.id)
                .map((v) => ({
                    ...v,
                    description: v.description.map((d) => ({
                        ...d,
                        type: d.type as "text" | "link",
                    })),
                    howToInstall: v.howToInstall?.map((h) => ({
                        ...h,
                        instructions: h.instructions.map((i) => ({
                            ...i,
                            type: i.type as "text" | "internalLink" | "link",
                        })),
                    })),
                }));
            setVariations(productVariations);

            // Check for the variation ID in the URL and set the corresponding variation
            const initialVariation = variationId
                ? productVariations.find((v) => v.variationId === parseInt(variationId))
                : productVariations[0];

            setSelectedVariation(initialVariation || null);
        }
    }, [product, variationId]);

    useEffect(() => {
        if (selectedVariation) {
            // Downloads
            const downloadFolderPath = `/assets/releases/${selectedVariation.releaseId}/variations/v${selectedVariation.variationId}/downloads`;
            fetch(`${API_BASE_URL}/api/list-downloads?path=${downloadFolderPath}`)
                .then((response) => response.json())
                .then((data) => setDownloadTypes(data.downloadTypes || []))
                .catch((error) => console.error('Error fetching download types:', error));
        }
    }, [selectedVariation]);

    const handleVariationChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedId = parseInt(event.target.value);
        const variation = variations.find((v) => v.variationId === selectedId) || null;
        setSelectedVariation(variation);
    };

    return (
        <div>
            {product && selectedVariation && (
                <ProductPageHeader
                    product={product}
                    variations={variations}
                    selectedVariation={selectedVariation}
                    handleVariationChange={handleVariationChange}
                />
            )}

            {selectedVariation && product && (
                <div>
                    <DescriptionGroup description={selectedVariation.description} />

                    <AddonGroup product={product} variation={selectedVariation} />

                    <GalleryGroup
                        zipName={`${product.slug}-v${selectedVariation.variationId}-${product.version}`}
                        galleryPath={`/assets/releases/${selectedVariation.releaseId}/variations/v${selectedVariation.variationId}/gallery`}
                    />

                    <RelatedGroup relatedItems={product.related ?? []} />
                </div>
            )}
        </div>
    );
};

export default ProductPage;

